module.exports = __webpack_public_path__ + "img/bittensor.cfefe308.svg";